<template>
  <!--Binds the text based on the status from nereus-->
  <span>{{getStatusIndicatorText()}}</span>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: ['instRD'],
  computed: {
    ...mapState({
      statusIndicators: (state) => state.statusIndicators,
    }),
  },
  methods: {
    // Helper method to filter through the statusIndicator information
    getStatusHelper() {
      let statusValue = _.get(this.statusIndicators, this.instRD);
      if (_.isEmpty(statusValue)) {
        statusValue = 'unset';
      }
      return statusValue.toLowerCase();
    },
    // Takes the status information and displays "Status" text
    getStatusIndicatorText() {
      const statusHolderText = this.getStatusHelper();
      const newStr = statusHolderText.replace(/-|_/g, ' ').toLowerCase();
      let text;
      if (_.isEmpty(statusHolderText)) {
        text = 'No status available';
      } else {
        text = newStr[0].toUpperCase() + newStr.substring(1);
      }
      return text;
    },
  },
};
</script>
